import React from 'react';
import { Box, Grid, Stack } from '@mui/material';
import InputField from 'dashboard/components/fields/InputField';
import BrandColorPresets from '../BrandColorPresets';

/**
 * Tab 0 — basic brand info: name, domain, brand color (+ preset picker),
 * city, country, industry, contract number, employee count.
 *
 * Receives prop builders (`commonProps`, `requiredProps`) from the parent
 * so the value/onChange/onBlur/error wiring is uniform across tabs.
 */
export default function InfoTab({ formData, setFormData, commonProps, requiredProps }) {
  return (
    <Grid container spacing='20px'>
      <Grid item xs={12} md={6}>
        <Stack direction='column' spacing='20px'>
          <InputField {...requiredProps('name')}   placeholder='Brand Name'        label='Brand Name' />
          <InputField {...requiredProps('domain')} placeholder='https://example.com' label='Brand Domain' />
          <Box>
            <InputField {...commonProps('brand_color')} placeholder='Brand Color' label='Brand Color' />
            <BrandColorPresets
              value={formData.brand_color || ''}
              onPick={(hex) => setFormData((prev) => ({ ...prev, brand_color: hex }))}
            />
          </Box>
          <InputField {...commonProps('city')} placeholder='City' label='City' />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <Stack direction='column' spacing='20px'>
          <InputField {...commonProps('country')}            placeholder='Country'              label='Country' />
          <InputField {...commonProps('industry')}           placeholder='Industry'             label='Industry' />
          <InputField {...commonProps('contact_number')}     placeholder='Contact Number'       label='Contact Number' />
          <InputField {...commonProps('number_of_employee')} placeholder='Number of Employees'  label='Number of Employees' />
        </Stack>
      </Grid>
    </Grid>
  );
}
